export default "__VITE_ASSET__B6ZOsN$1__"